// import React, { useEffect, useState } from 'react'
// import { canteenMenu } from '../../../../../../API/API'
// //import classes from '../CanteenMenu/Canteen.module.scss';
// import classes from './Othersnacks.module.scss';
// //Added for Canteen Payments
// import toast from 'react-hot-toast';
// import { useNavigate } from 'react-router-dom';
// import { walletHistory } from '../../../../../../API/API'
// import { useDispatch, useSelector } from 'react-redux';
// import { closePaymenu }  from './../../../../../../Redux/action/interactions';
// //import PayMenu from './../../../../../../pages/CanteenList/CanteenPay/PayMenu';
// import PayMenuOthersnacks from '../../../../../../pages/CanteenList/CanteenPay/PayMenuOthersnacks';
// //End Add for Canteen Payments


// const OtherSnacks = () => {
//   const data = JSON.parse(localStorage.getItem('data'));
//   const userID = localStorage.getItem('userID');
//   //Add for Canteen Payments
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const modules = JSON.parse(localStorage.getItem('modules'));
//   const payMenu = useSelector(state => state.interactions.payMenu);
//   const [transHistory, setHistory] = useState([]);
  
//     useEffect(() => {
//         if (modules !== null && modules.includes('CANTEEN') !== true) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500
//             });
//         }

//         if (userID !== null & data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([])
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 })
//         }
//     }, [userID,payMenu])
//   //End Add for Canteen payments
//   const [menu, setMenu] = useState([{
//     Monday: [],
//     Tuesday: [],
//     Wednesday: [],
//     Thursday: [],
//     Friday: [],
//    }]);

//   const [todayMenu, setTodayMenu] = useState([])
//   const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//   let d = new Date();
//   let day = weekday[d.getDay()];


//   useEffect(() => {
//     if (data !== null && userID !== null) {
//       canteenMenu(userID, data.empid, data.token, data.company)
//         .then(response => {
//           const Monday = response.data.filter((item)=>{
//             return item.fday === "Monday"
//         })
//         const Tuesday = response.data.filter((item)=>{
//             return item.fday === "Tuesday"
//         })
//         const Wednesday = response.data.filter((item)=>{
//             return item.fday === "Wednesday"
//         })
//         const Thursday = response.data.filter((item)=>{
//             return item.fday === "Thursday"
//         })
//         const Friday = response.data.filter((item)=>{
//             return item.fday === "Friday"
//         })
//         const Saturday = response.data.filter((item)=>{
//             return item.fday === "Saturday"
//         })
//         setMenu({
//             Monday: Monday[0],
//             Tuesday: Tuesday[0],
//             Wednesday: Wednesday[0],
//             Thursday: Thursday[0],
//             Friday: Friday[0],
//             Saturday: Saturday.length === 0 ? {fday:"Saturday",bfast: "Weekend Off", lunch: "Weekend Off", htea: "Weekend Off", others: "Weekend Off"} : Saturday[0]
//         })
//         })
//     }    
//     return () => {
//     }

//   }, [userID])

//   useEffect(() => {
//     if (menu !== null) {
//       setTodayMenu(Object.values(menu).find(item => item.fday === day));
//     }
//   }, [menu, day]);


//   //Functions to add or Remove Items
//   const [menuItems, setMenuItems] = useState([]);
//   const handleAddItem = (itemName) => {
//     const existingItem = menuItems.find((item) => item.name === itemName);
//     if (existingItem) {
//       setMenuItems(
//         menuItems.map((item) =>
//           item.name === itemName ? { ...item, quantity: item.quantity + 1, amt: item.amt + parseFloat(itemName.split('-')[1]) } : item
//         )
//       );
//     } else {
//       if (menuItems.length === 0 ) {
//         setMenuItems([{ name: itemName, quantity: 1, amt: parseFloat(itemName.split('-')[1]) }]);
//         // handleAddItem(itemName);
//       }
//       setMenuItems([...menuItems, { name: itemName, quantity: 1, amt: parseFloat(itemName.split('-')[1]) }]);
//     }
//   };
//   const handleRemoveItem = (itemName) => {
//     setMenuItems((prevMenuItems) => {
//       const existingItemIndex = prevMenuItems.findIndex((item) => item.name === itemName);
  
//       if (existingItemIndex !== -1) {
//         const updatedItems = [...prevMenuItems];
  
//         if (updatedItems[existingItemIndex].quantity > 1) {
//           // Decrement quantity if greater than 1
//           updatedItems[existingItemIndex].quantity -= 1;
//           updatedItems[existingItemIndex].amt -= parseFloat(itemName.split('-')[1]);
//           return updatedItems;
//         } else {
//           // Remove item if quantity is 1
//           updatedItems.splice(existingItemIndex, 1);
//           return updatedItems;
//         }
//       } else {
//         // Item not found, no change needed
//         return prevMenuItems;
//       }
//     });
//   };
//   useEffect(() => {
//     localStorage.setItem('order', JSON.stringify(menuItems));
//   }, [menuItems]);



//   return (
//     <div className={classes.OtherSnacks}>
//       {todayMenu ?
//         (
//           <>
//           {payMenu && <PayMenuOthersnacks />}
//             <div>
//               {/* <h2>{todayMenu.fday} Canteen Menu</h2> */}
//               <h3>
//                 <table width="100%" >
//                   <tbody>
//                     <tr>
//                       <td width="20dvw">Order Summary</td>
//                       <td width="50dvw">{menuItems.map(items => items.name + '*' + items.quantity + '=' + items.amt).join(', ')}</td>
//                       <td rowSpan={2} width="30dvw">
//                         <span>
//                           { menuItems.reduce((sum, item) => sum + item.amt ,'') && <button onClick={()=>{dispatch(closePaymenu(true))}}>Pay</button> }
//                         </span>
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Total Amount</td>
//                       <td>{menuItems.reduce((sum, item) => sum + item.amt ,0) }</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </h3>
//               <table className={classes.tableData}>
//                 <tbody>
//                   <tr>
//                     <td valign='top'><h3>Other Snacks:</h3></td>
//                   </tr><tr>
//                   <td valign='top' style={{ display: "flex" , flexDirection:'column',gap:"0px"}} >
//                     <>{todayMenu.others ? (todayMenu.others.split('/').map(((item) => {    //{todayMenu.others ? (todayMenu.others.split('/').sort().map(((item) => {
//                       return <p className={classes.bottomBorder} key={item}>{item} 
//                       <span>
//                          <button className={classes.btnQty} onClick={() => handleRemoveItem(item)}>-</button>
//                         <button className={classes.btnQty} onClick={() => handleAddItem(item)}>+</button>
//                       </span>
//                       <br></br>&nbsp;<br></br><br></br><br></br></p>
//                     }))) : " "}</></td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </>
//         ) : (" ")}
//     </div>
//   )
// }

// export default OtherSnacks;








import React, { useEffect, useState } from 'react';
import { canteenMenu } from '../../../../../../API/API';
import classes from './Othersnacks.module.scss';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { walletHistory } from '../../../../../../API/API';
import { useDispatch, useSelector } from 'react-redux';
import { closePaymenu } from './../../../../../../Redux/action/interactions';
import PayMenuOthersnacks from '../../../../../../pages/CanteenList/CanteenPay/PayMenuOthersnacks';

const OtherSnacks = () => {
  const data = JSON.parse(localStorage.getItem('data'));
  const userID = localStorage.getItem('userID');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modules = JSON.parse(localStorage.getItem('modules'));
  const payMenu = useSelector((state) => state.interactions.payMenu);
  const [transHistory, setHistory] = useState([]);

  useEffect(() => {
    if (modules !== null && !modules.includes('CANTEEN')) {
      navigate('/dashboard/home');
      toast("Sorry You Can't Access this Link", {
        icon: '❗',
        duration: 4500,
      });
    }

    if (userID && data) {
      walletHistory(userID, data.empid, data.token)
        .then((response) => {
          setHistory(response.data);
        })
        .catch(() => {
          setHistory([]);
          toast("Unable to Fetch Wallet History", {
            icon: '❗',
            duration: 4500,
          });
        });
    }
  }, [userID, payMenu]);

  const [menu, setMenu] = useState({
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
  });

  const [todayMenu, setTodayMenu] = useState([]);
  const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const d = new Date();
  const day = weekday[d.getDay()];

  useEffect(() => {
    if (data && userID) {
      canteenMenu(userID, data.empid, data.token, data.company).then((response) => {
        const Monday = response.data.filter((item) => item.fday === "Monday");
        const Tuesday = response.data.filter((item) => item.fday === "Tuesday");
        const Wednesday = response.data.filter((item) => item.fday === "Wednesday");
        const Thursday = response.data.filter((item) => item.fday === "Thursday");
        const Friday = response.data.filter((item) => item.fday === "Friday");
        const Saturday = response.data.filter((item) => item.fday === "Saturday");

        setMenu({
          Monday: Monday[0],
          Tuesday: Tuesday[0],
          Wednesday: Wednesday[0],
          Thursday: Thursday[0],
          Friday: Friday[0],
          Saturday: Saturday.length === 0 ? { fday: "Saturday", bfast: "Weekend Off", lunch: "Weekend Off", htea: "Weekend Off", others: "Weekend Off" } : Saturday[0],
        });
      });
    }
  }, [userID]);

  useEffect(() => {
    if (menu) {
      setTodayMenu(Object.values(menu).find((item) => item.fday === day));
    }
  }, [menu, day]);

  const [menuItems, setMenuItems] = useState([]);

  const handleAddItem = (itemName) => {
    const [item, amount] = itemName.split('-');
    const existingItem = menuItems.find((item) => item.name === itemName);
    if (existingItem) {
      setMenuItems(
        menuItems.map((item) =>
          item.name === itemName ? { ...item, quantity: item.quantity + 1, amt: item.amt + parseFloat(amount) } : item
        )
      );
    } else {
      setMenuItems([...menuItems, { name: itemName, quantity: 1, amt: parseFloat(amount) }]);
    }
  };

  const handleRemoveItem = (itemName) => {
    const [item, amount] = itemName.split('-');
    setMenuItems((prevMenuItems) => {
      const existingItemIndex = prevMenuItems.findIndex((item) => item.name === itemName);

      if (existingItemIndex !== -1) {
        const updatedItems = [...prevMenuItems];

        if (updatedItems[existingItemIndex].quantity > 1) {
          updatedItems[existingItemIndex].quantity -= 1;
          updatedItems[existingItemIndex].amt -= parseFloat(amount);
          return updatedItems;
        } else {
          updatedItems.splice(existingItemIndex, 1);
          return updatedItems;
        }
      } else {
        return prevMenuItems;
      }
    });
  };

  useEffect(() => {
    localStorage.setItem('order', JSON.stringify(menuItems));
  }, [menuItems]);

  return (
    <div className={classes.OtherSnacks}>
      {todayMenu ? (
        <>
          {payMenu && <PayMenuOthersnacks />}
          <div>
            <h3>
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="20dvw">Order Summary</td>
                    <td width="50dvw">{menuItems.map((items) => items.name + '*' + items.quantity + '=' + items.amt).join(', ')}</td>
                    <td rowSpan={2} width="30dvw">
                      <span>
                        {menuItems.reduce((sum, item) => sum + item.amt, 0) > 0 && <button onClick={() => { dispatch(closePaymenu(true)); }}>Pay</button>}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Total Amount</td>
                    <td>{menuItems.reduce((sum, item) => sum + item.amt, 0)}</td>
                  </tr>
                </tbody>
              </table>
            </h3>
            <table className={classes.tableData}>
              <tbody>
                <tr>
                  <td valign="top"><h3>Other Snacks:</h3></td>
                </tr>
                <tr>
                  <td valign="top" style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
                    <>
                      {todayMenu.others ? (
                        todayMenu.others.split('/').sort().map((item) => {
                          return (
                            <p className={classes.bottomBorder} key={item}>
                              {item}
                              <span>
                                <button className={classes.btnQty} onClick={() => handleRemoveItem(item)}>-</button>
                                <button className={classes.btnQty} onClick={() => handleAddItem(item)}>+</button>
                              </span>
                              <br />
                              &nbsp;<br /><br /><br />
                            </p>
                          );
                        })
                      ) : (
                        " "
                      )}
                    </>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ) : (
        " "
      )}
    </div>
  );
};

export default OtherSnacks;















